let ALERTMESSAGES: any = {};

ALERTMESSAGES = {
   LeadInsertSuccess:"Lead added successfully.",
   Registration:"User register successfully.",
   Registration_Info:"User register successfully, We will verify your school and get back to you.",
   DEFAULT:"Something went wrong...",
   VERIFYEMAIL:"Welcome to ClearSheets. You are almost ready to stop grading papers and to start your Worksheet Revolution! We sent you an email, please check your email and click the verify email link we sent. Check your spam folder if you do not find the email.",
   FORMSUBMITTED: "Form Submitted Successfully"
}
export default ALERTMESSAGES;